"use client";
import React from "react";
import { ShowMoreButton } from "@/app/(components)/Basic/ShowMoreButton";

export interface Props {
  onLoadMore: () => void;
  visible?: boolean;
  moreLabel?: string;
}

function MasonryFooter({ visible, onLoadMore, moreLabel }: Props) {
  if (!visible) return null;

  return (
    <ShowMoreButton
      fetchNextPage={onLoadMore}
      label={moreLabel}
      className="mt-6 md:mt-20"
    />
  );
}

export default MasonryFooter;
